export default __webpack_public_path__ + "a2a79cd02eb2645892eb41d8a29ef8b0.png";